export const SDK_STATUSES = {
    SUCCESS: "SUCCESS",
    CANCELLED: "CANCELLED",
} as const;

export const ORDER_STATUSES = {
    AUTHENTICATED: "authenticated",
    PROCESSING: "processing",
    PENDING: "pending",
    COMPLETE: "complete",
    FULFILLED: "fulfiled",
    VOID: "voided",
    REQUEST_TIMEOUT: "request_timeout",
    FULFILLMENT_ERROR: "fulfil_error",
};

export const POLLING_STATUS_CODES = [ORDER_STATUSES.AUTHENTICATED, ORDER_STATUSES.PROCESSING];

export const ERROR_CODES = ["OUT_OF_STOCK", "INVALID_RECIPIENT_EMAIL"];

export const CHECKOUT_FIELDS = "gift_card_order_customer_fields";

export type ORDER_STATUS = typeof ORDER_STATUSES[keyof typeof ORDER_STATUSES];
